<template>
  <vehicle-status-panel title="海康车辆状态查询" source="hik" :use-hik-api="true" />
</template>

<script>
import VehicleStatusPanel from '../components/VehicleStatusPanel'
export default {
  name: 'CheliangHikStatus',
  components: { VehicleStatusPanel }
}
</script>
